<!-- <app-sub-navbar></app-sub-navbar> -->
<app-nav-logo></app-nav-logo>

<div class="content">
    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col" style="text-align: right;">
                ภาคการเกษตร
                <select class="form-select mr-3" name="list_sector" id="list_sector"
                    (change)="selectNewYearAndSector('',$event.target.value)"
                    [(ngModel)]="sector_now">
                    <option *ngFor="let x of listsector" value="{{x.value}}">
                        {{x.name}}</option>
                </select>
                ข้อมูล ณ ปี
                <select class="form-select" name="list_year" id="list_year" (change)="selectNewYearAndSector($event.target.value,'')" [(ngModel)]="year_now">
                    <option *ngFor="let y of listYear" value="{{y}}">{{y}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3" *ngFor="let
                items of ProfileInfo">
                <div class="card">
                    <div class="card-header">
                        <h6 class="font-weight-bold">ข้อมูลทั่วไปกลุ่มเกษตกร</h6>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 col-md-12 col-sm-12" style="text-align: right;">
                            <i class="fa fa-eye fa-2x" aria-hidden="true"
                                style="width: 25px; vertical-align: middle; padding-bottom: 2px; color: black;"></i>
                            จำนวนผู้เข้าชม : {{viewer}} ครั้ง
                        </div>
                        <h5 class="mt-3 text-center text-blacks">"{{items.agriNameTh}} จำกัด"
                        </h5>
                        <div class="col-xl-12 text-right">
                            <p class="text-black-50">ข้อมูล ณ ปี {{items.dataYear}}</p>
                        </div>
                        <table class="w-100">
                            <tbody>
                                <tr>
                                    <td>
                                        <i class="fas fa-qrcode"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">รหัสกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.registryNo2 || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-file-signature"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ชื่อกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.agriNameTh}} จำกัด</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-layer-group"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ประเภทกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.agriTypeName || '-'}} ({{items.groupNameTh || '-'}})
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-map-marker-alt"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ที่อยู่
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : เลขที่ {{items.locAddr || '-'}} ตำบล{{items.tambonName || '-'}}
                                            อำเภอ{{items.amphurName || '-'}} จังหวัด{{items.provinceName || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-phone-volume"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">เบอร์โทรศัพท์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.telNo}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-calendar"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">วันที่จดทะเบียนกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.registryDate || '-'}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-envelope"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">อีเมล
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.managerEmail || '-'}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-check-circle"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">สถานะกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.agriStatusName || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-check-circle"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">มาตรฐานกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.agriStandard
                                            == '1'">
                                            : ผ่านมาตรฐานกลุ่มเกษตกร</p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.agriStandard
                                            == '2'">
                                            : ไม่ผ่านมาตรฐานกลุ่มเกษตกร</p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.agriStandard
                                            == '3'">
                                            : ไม่นำมาจัดมาตรฐานกลุ่มเกษตกร
                                        </p>
                                    </td>
                                </tr>
                                <tr *ngIf="items.coopStandard ==
                                    '3'">
                                    <td>
                                        <i class="fas fa-list"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">มาตรฐานกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.coopStandardDetail
                                            ==
                                            'no_count1'">เหตุที่ไม่นำมาจัดมาตรฐานกลุ่มเกษตกร : จัดตั้งใหม่ไม่ถึง 2 ปี</p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.coopStandardDetail
                                            ==
                                            'no_count2'">เหตุที่ไม่นำมาจัดมาตรฐานกลุ่มเกษตกร : หยุดดำเนินกิจการ
                                        </p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.coopStandardDetail
                                            ==
                                            'no_count3'">เหตุที่ไม่นำมาจัดมาตรฐานกลุ่มเกษตกร : อยู่ระหว่างชำระบัญชี
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-poll"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">จำนวนหุ้น
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.stock | number:'':'he'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-coins"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">มูลค่าหุ้น
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.amtStock | number:'':'he'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-calendar-alt"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">วันสิ้นปีทางบัญชี
                                        </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '1'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : มกราคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '2'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : กุมภาพันธ์ </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '3'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : มีนาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '4'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : เมษายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '5'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : พฤษภาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '6'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : มิถุนายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '7'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : กรกฎาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '8'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : สิงหาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '9'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : กันยายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '10'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : ตุลาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '11'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : พฤศจิกายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '12'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : ธันวาคม </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-user-tag"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ประธานกรรมการกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.cmtTitle || '-'}} {{items.cmtName || '-'}}
                                            {{items.cmtSname || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-user-tag"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">จำนวนพนักงาน
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.officer || '-'}} คน
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-user-tag"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ผู้จัดการกลุ่มเกษตกร
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.mngTitle || '-'}} {{items.mngName || '-'}}
                                            {{items.mngSname || '-'}}
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngFor="let
                items of
                ProfileInfo">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-4">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="font-weight-bold">จำนวนสมาชิกกลุ่มเกษตกร</h6>
                            </div>
                            <div class="card-body p-3">
                                <div class="row p-0 m-0">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{items.dataYear}}
                                        </p>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12
                                        col-sm-12
                                        d-flex">
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">ชาย {{items.memberM+items.memberJoinM | number:'':'he'}}
                                                คน
                                            </h6>
                                            <img src="/assets/images/user_1.png" class="member mt-3" alt="">
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">หญิง {{items.memberFm+items.memberJoinFm |
                                                number:'':'he'}} คน
                                            </h6>
                                            <img src="/assets/images/user_2.png" class="member mt-3" alt="">
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-lg-12
                                        text-center mt-4">
                                        <h5>รวม {{items.member+items.memberJoin | number:'':'he'}} คน</h5>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-lg-12
                                    text-center mt-4">
                                        <h6>*จำนวนสมาชิกกลุ่มเกษตกรรวมสมาชิกที่ร่วมธุรกิจกับกลุ่มเกษตกร</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-4">
                        <div class="card h-100">
                            <div class="card-header">
                                <h6 class="font-weight-bold">จำนวนกรรมการกลุ่มเกษตกร</h6>
                            </div>
                            <div class="card-body p-3">
                                <div class="col-xl-12 text-right">
                                    <p class="text-black-50">ข้อมูล ณ ปี {{items.dataYear}}
                                    </p>
                                </div>
                                <div class="row p-0 m-0">
                                    <div class="col-xl-12 col-lg-12 col-md-12
                                        col-sm-12
                                        d-flex">
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">ชาย {{items.committeeM | number:'':'he'}} คน</h6>
                                            <img src="/assets/images/employee_2.png" class="member mt-3" alt="">
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">หญิง {{items.committeeFm | number:'':'he'}} คน</h6>
                                            <img src="/assets/images/employee_1.png" class="member mt-3" alt="">
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-lg-12
                                        text-center mt-4">
                                        <h5>รวม {{SumCommittee | number:'':'he'}} คน</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="row" *ngIf="defect_on == true && defect_verify == true">
                    <div class="col-xl-12 col-md-12 col-sm-12 mt-4">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="font-weight-bold">ข้อบกพร่อง</h6>
                            </div>
                            <div class="card-body p-3">
                                <div class="col-xl-12 text-right">
                                    <h6 class="text-center p-2 mt-3">ข้อมูล ณ
                                        วันที่
                                        {{Date_after_day}} {{Month_now}}
                                        {{year_now_}}
                                    </h6>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12
                                text-center mt-5" *ngIf="check_Data == true">
                                    <p>- ไม่พบข้อบกพร่อง -</p>
                                </div>
                                <table class="table table-hover" *ngIf="check_Data == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th width="15%"> ลำดับที่ </th>
                                            <th> หัวข้อ </th>
                                            <th> สถานะ </th>
                                        </tr>
                                    </thead>

                                    <tbody *ngFor="let items of CoopDefect;
                                        index
                                        as i">
                                        <tr>
                                            <td>
                                                <p>{{i+1}}</p>
                                            </td>
                                            <td>
                                                <p>{{items.defectSubjectDetail}}</p>
                                            </td>
                                            <td>
                                                <p>{{items.solvMainDetail}}</p>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                                <div class="col-xl-12 text-right">
                                    <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>


        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="card-header">
                        <b>งบแสดงฐานะทางการเงิน</b>
                    </div>
                    <div class="row pl-2 pr-2 mb-2">
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    สินทรัพย์ของกลุ่มเกษตกร
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_FinanceFive}}</p>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{netAssets_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมกลุ่มเกษตกร</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    หนี้สินของกลุ่มเกษตกร
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_FinanceFive}}</p>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{liabilities_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv2"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมกลุ่มเกษตกร</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    ทุนของกลุ่มเกษตกร
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_FinanceFive}}</p>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{coopCapital_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv3"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมกลุ่มเกษตกร</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    กำไร (ขาดทุน)ของกลุ่มเกษตกร
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_FinanceFive}}</p>
                                    </div>

                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{netProfit_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv4"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมกลุ่มเกษตกร</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="depositVal1Show == true || creditVal1Show == true || saleVal1Show == true || collectVal1Show == true || transformVal1Show == true || serviceVal1Show == true">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="card-header">
                        <b>ปริมาณธุรกิจกลุ่มเกษตกร</b>
                    </div>
                    <div class="row pl-2 pr-2 mb-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="depositVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_deposit"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="creditVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_lend">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="saleVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_products">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="collectVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_produce">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="transformVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_Processing">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="serviceVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทธุรกิจบริการ
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_service">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="memberBusinessShow == true || memDepositShow == true || memCreditShow == true || memSaleShow == true || memGoodShow == true || memMarketingShow == true || memServiceShow == true || memOtherShow == true">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="card-header">
                        <b>การมีส่วนร่วมทำธุรกิจกับกลุ่มเกษตกรของสมาชิก</b>
                    </div>
                    <div class="row pl-2 pr-2 mb-2">
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memberBusinessShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memDepositShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทรับฝากเงิน
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Deposit}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Deposit">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memCreditShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทสินเชื่อ
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Credit}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Credit">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memSaleShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทจัดหาสินค้ามาจำหน่าย
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Sale}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Sale">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memGoodShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทแปรรูปผลผลิต
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Good}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Good">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memMarketingShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทรวบรวมผลผลิต
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Mageting}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Mageting">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memServiceShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทธุรกิจบริการ
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Service}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Service">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memOtherShow == true">
                            <div class=" card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกกลุ่มเกษตกร ประเภทธุรกิจอื่น ๆ
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_Pratic_Other}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Other">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-4" *ngIf="statusSector == 'กลุ่มเกษตกรภาคการเกษตร'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="tab">
                        <ul class="nav nav-tabs">
                            <li class="">
                                <a class="" id="asset" (click)="Assets($event.target.id)" [ngClass]="(asset ==
                                    true)?'active':''">อุปกรณ์การตลาด</a>
                            </li>
                            <li class="">
                                <a class="" id="machine" (click)="Machine($event.target.id)" [ngClass]="(machine ==
                                    true)?'active':''">เครื่องจักรกลการเกษตร</a>
                            </li>
                        </ul>
                    </div>
                    <ng-container *ngIf="asset">
                        <div class="card-header">
                            <p>อุปกรณ์การตลาด </p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12
                                text-center" *ngIf="check_Length_3 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-6
                                    col-sm-12">
                                    <div class="table-responsive">
                                        <table class="table table-hover" *ngIf="check_Length_3
                                            == false">
                                            <thead>
                                                <tr class="table-active">
                                                    <th scope="col">ลำดับ</th>
                                                    <th scope="col">รายการอุปกรณ์การตลาด</th>
                                                    <th scope="col">การใช้ประโยชน์</th>
                                                    <th scope="col">จำนวน</th>
                                                    <th scope="col">หน่วยนับ (จำนวน)
                                                    </th>
                                                    <th scope="col">กำลังการผลิต</th>
                                                    <th scope="col">หน่วยนับ (จำนวน)
                                                    </th>
                                                    <th scope="col">งบปี</th>
                                                    <th scope="col">โครงการ</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let items of
                                                AssetYear; index
                                                as
                                                i">
                                                <tr>
                                                    <th scope="row" class="table-active">{{i+1}}</th>
                                                    <th scope="row">{{items.assetDesc}}</th>
                                                    <th scope="row">{{items.rvMeaningStatus}}</th>
                                                    <th scope="row">{{items.qty | number:'':'he'}}
                                                    </th>
                                                    <th scope="row">{{items.qtyUom}}</th>
                                                    <th scope="row">{{items.size | number:'':'he'}}
                                                    </th>
                                                    <th scope="row">{{items.sizeUom}}</th>
                                                    <th scope="row">{{items.purchaseYear}}</th>
                                                    <th scope="row">{{items.bgtRemark}}
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-xl-12 text-right">
                                <p>ที่มา : กรมส่งเสริมกลุ่มเกษตกร</p>
                            </div> -->
                        </div>
                    </ng-container>

                    <ng-container *ngIf="machine">
                        <div class="card-header">
                            <p>เครื่องจักรกลการเกษตร</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12
                                text-center" *ngIf="check_Length_4 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover" *ngIf="check_Length_4
                                    == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">รายการเครื่องจักรกลการเกษตร</th>
                                            <th scope="col">การใช้ประโยชน์</th>
                                            <th scope="col">จำนวน</th>
                                            <th scope="col">หน่วยนับ (จำนวน)
                                            </th>
                                            <th scope="col">กำลังการผลิต</th>
                                            <th scope="col">หน่วยนับ (จำนวน)
                                            </th>
                                            <th scope="col">การนำไปใช้งาน</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let items of
                                            MachinesByRegister;
                                            index
                                            as
                                            i">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.assetDesc}}</th>
                                            <th scope="row">{{items.rvMeaningStatus}}</th>
                                            <th scope="row">{{items.agriQty | number:'':'he'}}
                                            </th>
                                            <th scope="row">{{items.agriQtyUom}}</th>
                                            <th scope="row">{{items.agriSize | number:'':'he'}}
                                            </th>
                                            <th scope="row">{{items.agriSizeUom}}</th>
                                            <th scope="row">{{items.rvMeaningStep}}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- <div class="col-xl-12 text-right">
                                <p>ที่มา : กรมส่งเสริมกลุ่มเกษตกร</p>
                            </div> -->
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="tab">
                        <ul class="nav nav-tabs">
                            <li class="">
                                <a class="" id="cpd" (click)="CPD($event.target.id)" [ngClass]="(cpd ==
                                    true)?'active':''">ข้อมูลพื้นที่เพาะปลูก
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- <ng-container *ngIf="rice">
                        <div class="card-header">
                            <p>พื้นที่เพาะปลูกข้าว</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{riceyear}}
                                </p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">พื้นที่เพาะปลูก ข้าว (ไร่)</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let items of ViewRiceOracleSumYear;
                                        index
                                        as
                                        i">
                                        <tr *ngIf="i >= 0">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.totalRai | number:'':'he'}}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container> -->

                    <!-- <ng-container *ngIf="rubber">
                        <div class="card-header">
                            <p>พื้นที่เพาะปลูกยาง</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">พื้นที่เพาะปลูก ยาง (ไร่)</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let items of ViewRubberOracleSumYear;
                                        index
                                        as
                                        i">
                                        <tr *ngIf="i >= 0">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.totalRai | number:'':'he'}}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container> -->

                    <ng-container *ngIf="cpd">
                        <div class="card-header">
                            <p>พื้นที่</p>
                        </div>
                        <div class="card-body p-3">
                            <!-- <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div> -->
                            <div class="col-lg-12 col-md-12 col-sm-12 text-center" *ngIf="check_Length_2 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover" *ngIf="check_Length_2 == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col"></th>
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">ประเภท</th>
                                            <th scope="col">จำนวนสมาชิก (คน)</th>
                                            <th scope="col">พื้นที่เพาะปลูก (ไร่)</th>
                                        </tr>
                                    </thead>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนเกษตรกร
                                    </th>
                                    <tbody *ngFor="let items of ViewOaeOracleSumYear; index as i">
                                        <tr *ngIf="items.groupCode == '1' ">
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '1' ">{{items.type}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '1' ">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row" *ngIf="items.groupCode == '1' ">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g1 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active">
                                        ทะเบียนเลี้ยงสัตว์</th>
                                    <tbody *ngFor="let items of ViewOaeOracleSumYear; index as i">
                                        <tr *ngIf="items.groupCode == '2' ">
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '2' ">{{items.typeDetail}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '2' ">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row" *ngIf="items.groupCode == '2' ">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g2 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนประมง</th>
                                    <tbody *ngFor="let items of ViewOaeOracleSumYear; index as i">
                                        <tr *ngIf="items.groupCode == '3' ">
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '3' ">{{items.typeDetail}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '3' ">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row" *ngIf="items.groupCode == '3' ">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g3 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนผู้ปลูกยาง
                                    </th>
                                    <tbody *ngFor="let items of ViewRubberOracleSumYear; index as i">
                                        <tr>
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row">ยาง</td>
                                            <td scope="row">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g4 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="row mt-4" *ngIf="statusSector == 'กลุ่มเกษตกรนอกภาคการเกษตร'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="card mt-5">
                    <div class="tab">
                        <ul class="nav nav-tabs">
                            <li class="">
                                <a class="" id="product" [ngClass]="(product ==
                                    true)?'active':''" (click)="Product($event.target.id)">รวบรวมผลผลิต</a>
                            </li>
                        </ul>
                    </div>

                    <ng-container *ngIf="product">
                        <div class="card-header">
                            <p>รวบรวมผลผลิต</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12
                                text-center" *ngIf="check_Length_5 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover" *ngIf="check_Length_5
                                    == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">รายการรวบรวมลำดับที่ 1
                                            </th>
                                            <th scope="col">รายการรวบรวมลำดับที่ 2
                                            </th>
                                            <th scope="col">รายการรวบรวมลำดับที่ 3
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let items of CollectYear;
                                            index
                                            as
                                            i">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.collect1}}</th>
                                            <th scope="row">{{items.collect2}}</th>
                                            <th scope="row">{{items.collect3}}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>
